import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { getTenantConfig } from './utils';

dayjs.extend(utc);
dayjs.extend(timezone);

export const DD_MMM_YYYY = 'DD-MMM-YYYY';
export const DD_MMM_YYYY_HH_MM = 'DD-MMM-YYYY HH:mm';

export const DATE_FORMATS = {
  DDD: 'ddd',
  DD_MMM: 'DD-MMM',
  MMM_YYYY: 'MMM YYYY',
  YYYY_MM_DD: 'YYYY-MM-DD',
  DD_MM_YYYY: 'DD-MM-YYYY',
  DD_MMM_DDD: 'DD-MMM (ddd)',
  MMM_DD_YYYY: 'MMM DD, YYYY',
  FULL_DATE: 'dddd, MMMM DD, YYYY',
  DD_MMM_YYYY_DDD: 'DD-MMM-YYYY (ddd)',
} as const;

export const formatDate = (date?: any, format?: string): string => {
  if (!date) return '';

  const config = getTenantConfig();
  const formatToUse = format || config.dateFormat || DD_MMM_YYYY;
  const d = dayjs.utc(date).tz(config.timezone);
  return d.isValid() ? d.format(formatToUse) : '';
};

export const formatTime = (date?: any, format?: string): string => {
  if (!date) return '--';

  const config = getTenantConfig();
  const formatToUse = format || config.timeFormat || 'HH:mm';
  const d = dayjs.utc(date).tz(config.timezone);
  return d.isValid() ? d.format(formatToUse) : '--';
};

export const parseTime = (
  time?: any,
  inputFormat: string = 'HH:mm:ss',
  outputFormat?: string
): string => {
  if (!time) return '';
  const config = getTenantConfig();
  const formatToUse = outputFormat || config.timeFormat || 'HH:mm';

  const d = dayjs(time, inputFormat);
  return d.isValid() ? d.format(formatToUse) : '--';
};

export const formatDateTime = (dateTime?: any, format?: string): string => {
  if (!dateTime) return '';

  const config = getTenantConfig();
  const formatToUse = format || config.dateTimeFormat || DD_MMM_YYYY_HH_MM;
  const d = dayjs.utc(dateTime).tz(config.timezone);
  return d.isValid() ? d.format(formatToUse) : '';
};

export const handleDateToBackend = (date?: any): string | undefined => {
  if (!date) return undefined;
  const d = dayjs(date);
  return d.isValid() ? d.format(DATE_FORMATS.YYYY_MM_DD) : undefined;
};

export const handleDateTimeToBackend = (dateTime?: any) => {
  if (!dateTime) return null;

  const config = getTenantConfig();
  const d = dayjs(dateTime);

  if (!d.isValid()) return null;
  const zonedDate = d.tz(config.timezone, true);
  return zonedDate.utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
};

export const isSameDay = (start?: any, end?: any): boolean => {
  if (!start || !end) return true;

  const config = getTenantConfig();
  const s = dayjs.utc(start).tz(config.timezone);
  const e = dayjs.utc(end).tz(config.timezone);
  return s.isValid() && e.isValid()
    ? s.format(DATE_FORMATS.DD_MM_YYYY) === e.format(DATE_FORMATS.DD_MM_YYYY)
    : true;
};
